var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1605 8.06396H14.6885C15.0725 7.39196 15.2645 6.62396 15.3605 5.75996C15.7445 3.55196 14.0165 1.63196 11.8085 1.63196H11.2325C10.8485 1.63196 10.4645 2.01596 10.4645 2.39996V4.70396C10.4645 6.52796 9.50447 8.25596 7.87247 9.21596V21.216L8.64047 21.792C9.21647 22.176 9.88847 22.464 10.5605 22.464H19.0085C20.6405 22.464 21.9845 21.312 22.1765 19.776L23.4245 11.808C23.8085 9.88796 22.4645 8.06396 20.1605 8.06396ZM1.92047 21.792H4.41647C5.18447 21.792 5.85647  21.12 5.85647 20.352V10.56C5.85647 9.79196 5.18447 9.11996 4.41647 9.11996H1.92047C1.15247 9.11996 0.480469 9.79196 0.480469 10.56V20.352C0.480469 21.12 1.15247 21.792 1.92047 21.792Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.e0a3985ac03c5129d7bd55098eb4037e.svg";
export { ForwardRef as ReactComponent };